import { lazy } from "react";
import { Navigate } from "react-router-dom";

const HomePageLayout = lazy(() => import("../layouts/HomePageLayout.jsx"));

const DesignLayout = lazy(() => import("../layouts/DesignLayout.jsx"));
const SubmissionLayout = lazy(() => import("../layouts/SubmissionLayout.jsx"));
const ResultLayout = lazy(() => import("../layouts/ResultLayout.jsx"));
const DssLayout = lazy(() => import("../layouts/DssLayout.jsx"));
const UserLayout = lazy(() => import("../layouts/UserLayout.jsx"));
const ContactsLayout = lazy(() => import("../layouts/ContactsLayout.jsx"));
const ErrorLayout = lazy(() => import("../layouts/ErrorLayout.jsx"));
const SupportLayout = lazy(() => import("../layouts/SupportLayout.jsx"));
const AdminLayout = lazy(() => import("../layouts/AdminLayout.jsx"));
const MediaLayout = lazy(() => import("../layouts/MediaLayout.jsx"));


const HomePageView = lazy(() => import("../views/home/HomePageView.jsx"));

const CategoryTemplatesPage = lazy(() => import("../views/templates/CategoryTemplatesPage.jsx"));

const InfoPage = lazy(() => import("../views/info/InfoPage.jsx"));

const DesignHomeView = lazy(() => import("../views/design/DesignHomeView.jsx"));
const PreviewHomeView = lazy(() => import("../views/design/preview/PreviewHomeView.jsx"));
const SubmissionHomeView = lazy(() => import("../views/submission/SubmissionHomeView.jsx"));
const SubmissionSuccessView = lazy(() => import("../views/submission/SubmissionSuccessView.jsx"));
const SubmissionClosedView = lazy(() => import("../views/submission/SubmissionClosedView.jsx"));
const SubmissionInvalidView = lazy(() => import("../views/submission/SubmissionInvalidView.jsx"));

const UserFormDashBoard = lazy(() => import("../views/user/myForms/FormsDashboard.jsx"));
const ContactsManager = lazy(() => import("../views/user/myContacts/ContactsManager.jsx"));

const AccountView = lazy(() => import("../views/user/account/AccountView.jsx"));

const SignInView = lazy(() => import("../views/dss/SignInView.jsx"));
const SignUpView = lazy(() => import("../views/dss/SignUpView.jsx"));
const EmailRegistrySuccessView = lazy(() => import("../views/dss/EmailRegistrySuccessView.jsx"));
const PasswordResetView = lazy(() => import("../views/dss/PasswordResetView.jsx"));
const PasswordUpdateView = lazy(() => import("../views/dss/PasswordUpdateView.jsx"));
const PasswordUpdateSuccessView = lazy(() => import("../views/dss/PasswordUpdateSuccessView.jsx"));

const UnAuthorizedView = lazy(() => import("../views/error/UnAuthorizedView.jsx"));
const InvalidResourceView = lazy(() => import("../views/error/InvalidResourceView.jsx"));

const SupportHomeView = lazy(() => import("../views/support/SupportHomeView.jsx"));
const SupportSuccess = lazy(() => import("../views/support/SupportSuccess.jsx"));


const AdminTemplatesView = lazy(() => import("../views/admin/AdminTemplatesView.jsx"));
const AdminViewTemplateView = lazy(() => import("../views/admin/AdminViewTemplateView.jsx"));
const AdminTemplateCategoryView = lazy(() => import("../views/admin/AdminTemplateCategoryView.jsx"));
const AdminTemplateSuggestionsView = lazy(() => import("../views/admin/AdminTemplateSuggestionsView.jsx"));

const MediaLightBox = lazy(() => import("../views/media/MediaLightbox.jsx"));


/** Research & Development */
const ResearchDevelopmentView = lazy(() => import("../R&D/ResearchDevelopmentView.jsx"));
const GeminiAiView = lazy(() => import("../R&D/GeminiAiView.jsx"));
const HomePage = lazy(() => import("../R&D/homepage/App.jsx"));
const DigitalSignature = lazy(() => import("../R&D/MuiSignaturePad.jsx"));
const AddressForm = lazy(() => import("../R&D/UltramodernAddressForm.jsx"));
const MultiImageUploader = lazy(() => import("../R&D/SubmissionMultiImageUploader.jsx"));
const FillableText = lazy(() => import("../R&D/fillableText/FillableText.jsx"));
const WorkflowWorkspace = lazy(() => import("../R&D/workflow/WorkflowWorkspace.jsx"));
const ParentDashboard = lazy(() => import("../R&D/template/ParentDashboard.jsx"));
const TemplateExplorer = lazy(() => import("../R&D/templateExplore/TemplateExplorerView.jsx"));
const FieldGroupHome =  lazy(() => import("../R&D/fieldGroup/FieldGroupHome.jsx"));
const TimePicker = lazy(() => import("../R&D/UniversalTimePicker.jsx"));

const ThemeRoutes = [

    {
        path: "/",
        element: <HomePageLayout />,
        children: [
            { path: "", exact: true, element: <HomePageView /> },
            { path: "templates/:categorySlug", exact: true, element: <CategoryTemplatesPage /> },
            { path: "info/:pageSlug", exact: true, element: <InfoPage /> },
        ]
    },


    {
        path: "/design",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <DesignHomeView /> },
            { path: "preview/*", exact: true, element: <PreviewHomeView /> },
        ]
    },

    {
        path: "/sub",
        element: <SubmissionLayout />,
        children: [
            { path: "closed", exact: true, element: <SubmissionClosedView /> },
            { path: "invalid", exact: true, element: <SubmissionInvalidView /> },
            { path: ":formId/:lookup?", exact: true, element: <SubmissionHomeView /> },
            { path: "success/:subId", exact: true, element: <SubmissionSuccessView /> }
        ]
    },

    {
        path: "/app-media",
        element: <MediaLayout />,
        children: [
            { path: "lightbox", exact: true, element: <MediaLightBox /> },
        ]
    },

    {
        path: "/dss",
        element: <DssLayout />,
        children: [
            { path: "signin", exact: true, element: <SignInView /> },
            { path: "signup", exact: true, element: <SignUpView /> },
            { path: "registry/success", exact: true, element: <EmailRegistrySuccessView /> },
            { path: "password/reset", exact: true, element: <PasswordResetView /> },
            { path: "password/update", exact: true, element: <PasswordUpdateView /> },
            { path: "password/update/success", exact: true, element: <PasswordUpdateSuccessView /> }
        ]
    },

    {
        path: "/u",
        element: <UserLayout />,
        children: [
            { path: "forms", exact: true, element: <UserFormDashBoard /> },//new
            { path: "contacts", exact: true, element: <ContactsManager /> },
            { path: "account", exact: true, element: <AccountView /> },
        ]
    },

    {
        path: "/contacts",
        element: <ContactsLayout />,
        children: [
            { path: "", exact: true, element: <ContactsManager /> },
        ]
    },

    {
        path: "/error",
        element: <ErrorLayout />,
        children: [
            { path: "unauthorized", exact: true, element: <UnAuthorizedView /> },
            { path: "invalid", exact: true, element: <InvalidResourceView /> },
        ]
    },

    {
        path: "/support",
        element: <SupportLayout />,
        children: [
            { path: "", exact: true, element: <SupportHomeView /> },
            { path: "success", exact: true, element: <SupportSuccess /> },
        ]
    },

    {
        path: "/admin",
        element: <AdminLayout />,
        children: [
            { path: "", exact: true, element: <Navigate to="templates" replace /> },
            { path: "templates", exact: true, element: <AdminTemplatesView /> },
            { path: "template/:id", exact: true, element: <AdminViewTemplateView /> },
            { path: "category", exact: true, element: <AdminTemplateCategoryView /> },
            { path: "suggestions", exact: true, element: <AdminTemplateSuggestionsView /> },
        ]
    },

    {
        path: "/rd",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <ResearchDevelopmentView /> },
            { path: "geminiAi", exact: true, element: <GeminiAiView /> },
            { path: "home", exact: true, element: <HomePage /> },
            { path: "sign", exact: true, element: <DigitalSignature /> },
            { path: "address", exact: true, element: <AddressForm /> },
            { path: "multiImageUploader", exact: true, element: <MultiImageUploader /> },
            { path: "fillableText", exact: true, element: <FillableText /> },
            { path: "workflow", exact: true, element: <WorkflowWorkspace /> },
            { path: "template", exact: true, element: <ParentDashboard /> },
            { path: "templateExplorer", exact: true, element: <TemplateExplorer /> },
            { path: "fieldGroup", exact: true, element: <FieldGroupHome /> },
            { path: "timePicker", exact: true, element: <TimePicker /> },

        ]
    }

]
export default ThemeRoutes;